module.exports = __webpack_public_path__ + "img/fig05.fcc72487.jpg";